import React, { useEffect } from "react";
import './banner-about.scss';
import hero from './../../image/me2.webp';
import { Link } from "react-router-dom";

const AboutBanner: React.FC = () => {
  

  return (
    <>
      <section className="banner-about container">
        <div className="wrapper">
          <div className="content-wrapper">
            <div className="image-wrapper">
              <img src={hero} alt="" />
            </div>
            <div className="text-wrapper">
              <div className="badge">
                <span>🎨 Product Designer</span>
              </div>
              <h2>Hi, I’m Alex 👋🏻</h2>
              <h3>your partner for digital solutions</h3>
              <p>Product Designer currently shaping high-impact experiences at Flutter Entertainment and previously Accenture, across sports betting, fintech, insurance, and automotive. I design for 20M+ users on iOS, Android, and web, blending design systems, experimentation, and business sense to turn complex, regulated journeys into simple, intuitive products.</p>

            </div>
          </div>

          <div className="info-wrapper">
            <div className="info-item">
              <span className="info-title">Years experience</span>
               <span className="info-content">3 +</span>
            </div>
            <div className="info-item">
              <span className="info-title">Users served</span>
               <span className="info-content">20M + </span>
            </div>
            <div className="info-item">
              <span className="info-title">Awards</span>
               <span className="info-content">x 2 </span>
            </div>
          </div>
        </div>
      </section>
      
    </>
  );
};

export default AboutBanner;
